export const PHONE_REGEX_WITHOUT_91 = /^[1-9]{1}[0-9]{9}$/;
export const DOUBLE_WHITESPACES = /^(?!.* {2}).+/;
export const PASSWORD =
  /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?.!@$%/^&*-]).{8,}$/;
export const VALIDATE_PIN_CODE = /^[1-9][0-9]{5}$/;
export const SINGLE_WHITESPACE = /^\S+$/;
export const VALIDATE_TAGS = /^[a-zA-Z0-9 ,]*$/
